import { defineComponent as _defineComponent } from 'vue'
import { Reaction } from '@padlet/arvo'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'
import uniqueId from 'lodash.uniqueid'
import { storeToRefs } from 'pinia'
import { useWindowSizeStore } from 'pinia/window_size'
import { computed } from 'vue'
import emitClickOnTouch from 'vuedirectives/emit_click_on_touch'

export default /*#__PURE__*/_defineComponent({
  __name: 'SurfacePostReactionLike',
  props: {
    sum: null,
    count: null,
    userReaction: null,
    isPadletColorSchemeDark: { type: Boolean },
    canReact: { type: Boolean },
    usageContext: null,
    postCid: null
  },
  emits: ['create', 'delete', 'edit-when-reaction-is-off'],
  setup(__props: any, { emit }) {

const props = __props as {
  sum: number
  count: number
  userReaction: Reaction | undefined
  isPadletColorSchemeDark: boolean
  canReact: boolean
  usageContext: 'postView' | 'postExpandedView'
  postCid: string
}




const isSmallerThanTabletPortrait = storeToRefs(useWindowSizeStore()).isSmallerThanTabletPortrait
const isUsedInPostExpandedView = computed(() => props.usageContext === 'postExpandedView')
const buttonId = `like-button-description-${props.postCid}-${uniqueId('likePostButton')}`
const currentUserReacted = computed(() => props.userReaction != null)
function toggleLike(): void {
  if (currentUserReacted.value) {
    emit('delete')
  } else if (props.canReact) {
    emit('create', 1)
  } else {
    emit('edit-when-reaction-is-off')
  }
}

const vEmitClickOnTouch = emitClickOnTouch

return { __sfc: true,emit, props, isSmallerThanTabletPortrait, isUsedInPostExpandedView, buttonId, currentUserReacted, toggleLike, vEmitClickOnTouch, OzIcon, OzTextButton, OzTextButtonColorScheme }
}

})